import { z } from "zod";

import { TestGroupDtoSchema } from "../../../../../dtos/deprecated/test-groups";

import { PluginFindReplaceSchema } from "./findReplaces";
import { PluginCampaignSchema_2023_08_20 } from "./testCampaign";

export * from "./findReplaces";
export * from "./testCampaign";

export const PluginTestGroupSchema_2023_08_20 = TestGroupDtoSchema.omit({
  isChosenWinner: true,
  isImpactWinner: true,
  priceChange: true,
  priceChangeUnit: true,
}).extend({
  testCampaign: PluginCampaignSchema_2023_08_20.nullish(),
  findReplaces: z.optional(PluginFindReplaceSchema.array()),
});
export type PluginTestGroupType_2023_08_20 = z.infer<
  typeof PluginTestGroupSchema_2023_08_20
> & {
  isExcluded?: boolean;
};
